import { getBaseURL } from "_common/utils";
import ActionButton   from "_components/molecules/mobileFeedActionButton";
import SharePopper    from "_components/molecules/sharePopper";

import useStyles from "./styles";

const component = ( {
	onClickLive,
	onClickCommentIcon,
	isVideoLike,
	feedId,
	setShowShareDrawer,
	showShareDrawer,
	commentCount,
	likeCount
} ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.container }>
			<SharePopper
				useModal
				getSrc      = { () => getBaseURL () + `/video/${ feedId }` }
				handleClose = { () => setShowShareDrawer ( false ) }
				open        = { showShareDrawer }
			/>

			<ActionButton
				activeIconName = "heartFilled"
				iconName       = { "heart" }
				isActive       = { isVideoLike }
				onClick        = { onClickLive }
				title          = { isVideoLike ? likeCount + 1 : likeCount }
			/>

			<ActionButton
				iconName = "message"
				onClick  = { onClickCommentIcon }
				title    = { commentCount ? commentCount : "Comment" }
			/>

			<ActionButton
				iconName = "share"
				onClick  = { () => setShowShareDrawer ( true ) }
				title    = "Share"
			/>
		</div>
	);
};

export default component;